"use client";
import {
  PopoverContextProvider,
  PopoverScopedContextProvider
} from "./MWF5B7KS.js";
import {
  CompositeContextProvider,
  CompositeScopedContextProvider
} from "./72IB6YNO.js";
import {
  createStoreContext
} from "./ILRXHV7V.js";

// src/select/select-context.tsx
import { createContext } from "react";
var ctx = createStoreContext(
  [PopoverContextProvider, CompositeContextProvider],
  [PopoverScopedContextProvider, CompositeScopedContextProvider]
);
var useSelectContext = ctx.useContext;
var useSelectScopedContext = ctx.useScopedContext;
var useSelectProviderContext = ctx.useProviderContext;
var SelectContextProvider = ctx.ContextProvider;
var SelectScopedContextProvider = ctx.ScopedContextProvider;
var SelectItemCheckedContext = createContext(false);
var SelectHeadingContext = createContext(null);

export {
  useSelectContext,
  useSelectScopedContext,
  useSelectProviderContext,
  SelectContextProvider,
  SelectScopedContextProvider,
  SelectItemCheckedContext,
  SelectHeadingContext
};
